import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon, MinusIcon } from "lucide-react"

import { cn } from "@/lib/utils"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-4 shrink-0 rounded-[4px] border border-skyline-2 bg-white text-skyline-2 shadow-xs transition-shadow outline-none data-[state=checked]:bg-skyline-2 data-[state=checked]:border-skyline-2 data-[state=checked]:text-white focus-visible:border-custom-outline focus-visible:ring-[3px] focus-visible:ring-custom-outline disabled:cursor-not-allowed disabled:opacity-100 disabled:border-skyline-2 disabled:text-skyline-2 disabled:data-[state=checked]:bg-skyline-2 disabled:data-[state=checked]:border-skyline-2 aria-invalid:border-custom-destructive-dark aria-invalid:focus-visible:ring-custom-destructive-dark active:border-custom-outline active:ring-[3px] active:ring-custom-outline",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        {props.checked === "indeterminate" ? (
          <MinusIcon className="size-3.5" />
        ) : (
          <CheckIcon className="size-3.5" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
